import type { ReactNode } from "react";

/** A section title — the `fawkes-section-header` vocabulary. */
export function SectionHeader({ children }: { children: ReactNode }) {
  return <h1 className="fui-section-header">{children}</h1>;
}
